
export default class Spouse {
  name?: string;
  surname?: string;
  idNumber?: string;
  address?: string;
  houseNumber?: string;
  zipCode?: string;
  city?: string;
  province?: string;
  country?: string;
  nationality?: string;
  email?: string;

  constructor(entity: Spouse) {
    this.name = entity.name || undefined;
    this.surname = entity.surname || undefined;
    this.idNumber = entity.idNumber || undefined;
    this.address = entity.address || undefined;
    this.houseNumber = entity.houseNumber || undefined;
    this.zipCode = entity.zipCode || undefined;
    this.city = entity.city || undefined;
    this.province = entity.province || undefined;
    this.country = entity.country || undefined;
    this.nationality = entity.nationality || undefined;
    this.email = entity.email || undefined;
  }
}



// WEBPACK FOOTER //
// ./src/value-objects/Spouse.tsx